import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgClose = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	stroke: "currentColor",
	strokeWidth: 2,
	strokeLinecap: "round",
	strokeLinejoin: "round",
	className: "lucide lucide-x",
	...props,
	children: [/* @__PURE__ */ _jsx("path", { d: "M18 6 6 18" }), /* @__PURE__ */ _jsx("path", { d: "m6 6 12 12" })]
});
export default SvgClose;
